export enum ErrorCode {
  NotFoundException = 'NotFoundException',
  AlreadyExist = 'AlreadyExist',
  InvalidOperation = 'InvalidOperation',
  CommoditiesAlreadyExistInOrders = 'CommoditiesAlreadyExistInOrders',
  CommoditiesAlreadyExistInTheCatalogue = 'CommoditiesAlreadyExistInTheCatalogue',
}
